export default "__VITE_ASSET__Dx0DaJvN__"